import styled from "styled-components";

export const HeaderControlsStyled = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;
